import { Entry } from '../Entry'

export function Entry20230719() {
  return (
    <Entry title="Jul 19 2023 - v3.4.6">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13950/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
